import React, { useState } from "react";
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  Typography,
  Button,
  Grid,
  Tooltip,
  Container,
} from "@material-ui/core";

import AttachmentIcon from "@material-ui/icons/Attachment";
import DeleteIcon from "@material-ui/icons/Delete";
import DownloadIcon from "@material-ui/icons/Download";

import { filter } from "lodash";
import { makeStyles } from "@material-ui/styles";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import * as locales from "@material-ui/core/locale";
import Scrollbar from "../../Scrollbar";
import { TablaHead, TablaToolbar } from "../../_dashboard/tablas";
import MyConfirmationDialog from "../../MyConfirmationDialog";
import CrearContrato from "./CrearContrato";
import { dbx } from "../../../utils/urlBack_End";
import { useSelector } from "react-redux";
import moment from "moment";
import { empleadosApi } from "src/services/empleadosApi";
import { clientesApi } from "src/services/clientesApi";

const TABLE_HEAD = [
  { id: "nombreArchivo", label: "Nombre", alignRight: false },
  { id: "fecha", label: "Fecha", alignRight: false },
  { id: "" },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => {
      return (
        _user.nombreArchivo.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.fecha.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    });
  }
  return stabilizedThis.map((el) => el[0]);
}

const styles = makeStyles(() => ({
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginTop: 20,
  },
  icon: {
    fontSize: "28px",
  },
}));

export default function TablaContrato(props) {
  const {
    contratos,
    empleado,
    setShowMessagePermiso,
    setColor,
    setMessage,
    vista,
  } = props;
  const {
    empleado: user,
    sucursal: sucursalObtenida,
    rol: rolObtenido,
  } = useSelector((state) => state.auth.user);
  const [adjuntar, setAdjuntar] = useState(false);
  const [showRemovalConfirmation, setShowRemovalConfirmation] = useState(false);
  const [contrato, setContrato] = useState("");
  const [deleteContratoEmpleado] =
    empleadosApi.useDeleteContratoEmpleadoMutation();
  const [deleteContratoCliente] =
    clientesApi.useDeleteContratoClienteMutation();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("nombreArchivo");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [locale] = useState("esES");
  const classes = styles();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = contratos?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - contratos?.length) : 0;

  const filteredUsers = applySortFilter(
    contratos,
    getComparator(order, orderBy),
    filterName,
  );

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const isUserNotFound = filteredUsers.length === 0;

  const crearContrato = () => {
    setAdjuntar(true);
  };

  const handleDeleteContrato = (contrato) => {
    setShowRemovalConfirmation(true);
    setContrato(contrato);
  };

  async function deleteFile(ruta) {
    try {
      await dbx.filesDeleteV2({
        path: `/${ruta}/${empleado.rut}/Contratos/` + contrato.nombreArchivo,
      });
      return true;
    } catch {
      return false;
    }
  }

  const eliminarContrato = async () => {
    if (vista === undefined) {
      try {
        await deleteContratoCliente(contrato.id).unwrap();
        setShowRemovalConfirmation(false);
        deleteFile("Clientes");
        setShowMessagePermiso(true);
        setColor("success");
        setMessage("Contrato Eliminado Correctamente");
      } catch {
        setShowRemovalConfirmation(false);
        setShowMessagePermiso(true);
        setColor("error");
        setMessage(
          "Ocurrió un error en el servidor. Inténtelo nuevamente más tarde.",
        );
      }
    } else {
      try {
        await deleteContratoEmpleado(contrato.id).unwrap();
        setShowRemovalConfirmation(false);
        deleteFile("Empleados");
        setShowMessagePermiso(true);
        setColor("success");
        setMessage("Contrato Eliminado Correctamente");
      } catch {
        setShowRemovalConfirmation(false);
        setShowMessagePermiso(true);
        setColor("error");
        setMessage(
          "Ocurrió un error en el servidor. Inténtelo nuevamente más tarde.",
        );
      }
    }
  };
  return (
    <div>
      <Card>
        <Typography variant="h5" component="h2" className={classes.title}>
          {vista === "EMPLEADO"
            ? "Mi Contrato"
            : vista === undefined
              ? "Archivos del Cliente"
              : "Contratos del Empleado"}
        </Typography>
        <Grid
          container
          style={{ padding: "1rem 1.5rem 0rem 1.5rem" }}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs md>
            <TablaToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
            />
          </Grid>
          {vista !== "EMPLEADO" && vista !== undefined && (
            <Grid item xs md>
              <Grid container direction="row-reverse">
                <Grid item xs={12} md={6}>
                  <Container style={{ marginLeft: ".5rem" }}>
                    <Button
                      variant="contained"
                      onClick={() => crearContrato()}
                      startIcon={<AttachmentIcon />}
                      style={{ minWidth: "170px" }}
                    >
                      Adjuntar Documento
                    </Button>
                  </Container>
                </Grid>
              </Grid>
            </Grid>
          )}

          {vista === undefined && rolObtenido !== "EMPLEADO" && (
            <Grid item xs md>
              <Grid container direction="row-reverse">
                <Grid item xs={12} md={6}>
                  <Container style={{ marginLeft: ".5rem" }}>
                    <Button
                      variant="contained"
                      onClick={() => crearContrato()}
                      startIcon={<AttachmentIcon />}
                      style={{ minWidth: "170px" }}
                    >
                      Adjuntar Documento
                    </Button>
                  </Container>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <TablaHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={contratos?.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const { nombreArchivo, fecha, urlArchivo } = row;
                    const isItemSelected =
                      selected.indexOf(nombreArchivo) !== -1;

                    return (
                      <TableRow
                        hover
                        key={nombreArchivo + fecha + urlArchivo}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Typography variant="subtitle2" noWrap>
                            {nombreArchivo}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          {fecha === ""
                            ? fecha
                            : moment(fecha, "YYYY/MM/DD").format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title="Descargar">
                            <Button
                              color="primary"
                              onClick={() => {
                                window.open(urlArchivo, "_blank");
                              }}
                            >
                              <DownloadIcon /> Descargar
                            </Button>
                          </Tooltip>
                          {vista !== "EMPLEADO" && vista !== undefined && (
                            <Tooltip title="Eliminar">
                              <Button
                                color="error"
                                onClick={() => {
                                  handleDeleteContrato(row);
                                }}
                              >
                                <DeleteIcon /> Eliminar
                              </Button>
                            </Tooltip>
                          )}

                          {vista === undefined &&
                            rolObtenido !== "EMPLEADO" && (
                              <Tooltip title="Eliminar">
                                <Button
                                  color="error"
                                  onClick={() => {
                                    handleDeleteContrato(row);
                                  }}
                                >
                                  <DeleteIcon /> Eliminar
                                </Button>
                              </Tooltip>
                            )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      No se han agregado elementos
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <ThemeProvider
          theme={(outerTheme) => createTheme(outerTheme, locales[locale])}
        >
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={contratos?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Card>

      {adjuntar && (
        <CrearContrato
          open={adjuntar}
          setOpen={setAdjuntar}
          empleado={empleado}
          titulo={
            empleado.apellidos !== undefined
              ? "Adjuntar Contrato del Empleado"
              : "Adjuntar Contrato del Cliente"
          }
          setShowMessagePermiso={setShowMessagePermiso}
          setColor={setColor}
          setMessage={setMessage}
        />
      )}

      <MyConfirmationDialog
        open={showRemovalConfirmation}
        onSubmit={() => eliminarContrato()}
        onClose={() => setShowRemovalConfirmation(false)}
        title="Eliminar Contrato"
        content="¿Está seguro de eliminar este documento?"
      />
    </div>
  );
}
